<placeme-layout-seo [seo]="job?.seo" [category]="job?.__typename">
  <placeme-jumbotron [seo]="job?.seo" [category]="job?.__typename"></placeme-jumbotron>
  <section class="main-content">
    <article class="description">
      <div class="page-markdown">
        <h2 class="description__title">{{ 'jobPage.offer.content.title' | translate }}</h2>
      </div>
      <div class="description__content container">
        <div class="description__content__container">
          <p class="description__content__container__text">
            {{ 'jobPage.offer.content.description' | translate }}
          </p>
          <markdown [data]="job?.content"></markdown>
          <a
            class="description__content__container__mailto"
            placeme-stroked-button
            target="_blank"
            [href]="'jobPage.offer.cta.href' | translate"
          >
            {{ 'jobPage.offer.cta.label' | translate }}
          </a>
        </div>
        <img
          class="description__content__illustration"
          [src]="'jobPage.offer.content.image.url' | translate"
          [alt]="'jobPage.offer.content.title' | translate"
        />
      </div>
    </article>

    <article class="competences">
      <div class="page-markdown">
        <h2 class="competences__title">{{ 'jobPage.skills.title' | translate }}</h2>
      </div>
      <div class="competences__container container">
        <div *ngFor="let icon of job?.seo.icons" class="competences__container__item">
          <div class="competences__container__item__img">
            <img [src]="icon.url" />
          </div>
        </div>
      </div>
    </article>

    <article class="advantages">
      <markdown class="page-markdown" [data]="'spiritPage.advantages.content' | translate"></markdown>
      <placeme-job-advantages [advantages]="'spiritPage.advantages.items' | translate"></placeme-job-advantages>
    </article>
  </section>

  <section class="join">
    <svg preserveAspectRatio="none" viewBox="0 0 1728 147" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0H72C144 0 288 0 432 14C576 28 720 56 864 63C1008 70 1152 56 1296 45.5C1440 35 1584 28 1656 24.5L1728 21V147H1656C1584 147 1440 147 1296 147C1152 147 1008 147 864 147C720 147 576 147 432 147C288 147 144 147 72 147H0V0Z"
        fill="#FFF"
      />
    </svg>
    <div class="float-container">
      <div class="join__container">
        <div class="join__container__content">
          <h1 class="join__container__content__title">
            {{ 'jobPage.spirit.content.title' | translate }}
          </h1>
          <p class="join__container__content__text">
            {{ 'jobPage.spirit.content.description' | translate }}
          </p>
          <div class="join__container__content__cta">
            <a class="join__container__content__cta__button" placeme-stroked-button [routerLink]="'jobPage.spirit.cta.href' | translate">
              {{ 'jobPage.spirit.cta.label' | translate }}</a
            >
            <a
              class="join__container__content__cta__button"
              placeme-fat-button
              target="_blank"
              [href]="'jobPage.offer.cta.href' | translate"
            >
              {{ 'jobPage.offer.cta.label' | translate }}
            </a>
          </div>
        </div>
        <img
          class="join__container__illustration"
          [src]="'jobPage.spirit.content.image.url' | translate"
          alt="join__container__illustration"
        />
      </div>
    </div>
  </section>
</placeme-layout-seo>
